import { Swiper, SwiperSlide } from "swiper/react";
import ArrowButton from "@components/ArrowButton";
import image01 from "./img/01.webp";
import image02 from "./img/02.webp";
import image03 from "./img/03.jpg";
import image04 from "./img/04.webp";
import googlePlay from "./img/google-play.png";
import appleStore from "./img/app-store.png";

import { renderToString } from "react-dom/server";
import { Pagination, Navigation } from "swiper/modules";
import "./style.scss";

import PaginationComponent from "@components/PaginationComponent";
import DOMPurify from "dompurify";

const sliderData = [
  {
    id: 0,
    title: "Schritt 1:<br/><strong> Lade die App herunter</strong>",
    description: "Wähle zuerst dein Gerät: iOS oder Android.",
    image: image01,
    stores: [
      {
        id: 1,
        name: "apple",
        image: appleStore,
        link: "https://apps.apple.com/de/app/nuviu/id1616197482",
      },
      {
        id: 2,
        name: "google",
        image: googlePlay,
        link: "https://play.google.com/store/apps/details?id=com.bat.myvuse.mobile",
      },
    ],
  },
  {
    id: 1,
    title: "<strong>APPLE-iPhone</strong>",
    description:
      "Bei iOS-Geräten lädst du die Nuviu-App aus dem App Store® herunter. Nach dem Herunterladen öffnest du Nuviu und besuchst my.vuse.com über den Browser der App.",
    image: image01,
    stores: [
      {
        id: 1,
        name: "apple",
        image: appleStore,
        link: "https://apps.apple.com/de/app/nuviu/id1616197482",
      },
    ],
  },
  {
    id: 2,
    title: "<strong>ANDROID-Smartphone</strong>",
    description:
      "Bei Android-Geräten lädst du die MYVUSE App bei Google Play herunter.",
    image: image02,
    stores: [
      {
        id: 1,
        name: "google",
        image: googlePlay,
        link: "https://play.google.com/store/apps/details?id=com.bat.myvuse.mobile",
      },
    ],
  },
  {
    id: 5,
    title:
      "Schritt 2:<br/> <strong> Anmelden oder ein Konto erstellen</storng>",
    description:
      "Wenn du neu bei Vuse bist, musst du ein Konto erstellen, bevor du dein Gerät koppeln kannst. Wenn du bereits ein Vuse Konto hast, meldest du dich wie gewohnt an.",
    image: image03,
  },
  {
    id: 6,
    title: "Schritt 3:<br/> <strong> Kopple dein Gerät</storng>",
    description:
      "Schalte die drahtlose Bluetooth-Verbindung ein und halte dein Smartphone in die Nähe deines Vuse-Geräts. Drücke schnell fünfmal die Seitentaste auf deinem Vuse Ultra Device. Folge den Anweisungen auf dem Bildschirm deines Telefons, um die Kopplung abzuschließen.",
    image: image04,
  },
];

function movePagination(swiper) {
  const pagination = document.querySelector(".pagination-swiper");
  if (!pagination) return;

  const activeSlide = swiper.slides[swiper.activeIndex];
  const footer = activeSlide?.querySelector(".footer-content");

  if (footer && !footer.contains(pagination)) {
    footer.appendChild(pagination);
  }
}

export default function DownloadSlider() {
  return (
    <div>
      <div className="custom-slider">
        <div className="pagination-swiper" />
        <Swiper
          loop
          className="main-swiper"
          spaceBetween={50}
          slidesPerView="auto"
          modules={[Pagination, Navigation]}
          pagination={{
            el: ".pagination-swiper",
            type: "custom",
            renderCustom: (_, current, total) =>
              renderToString(
                <PaginationComponent current={current} total={total} />,
              ),
          }}
          navigation={{
            nextEl: ".swiper-button-next.hero",
            prevEl: ".swiper-button-prev.hero",
          }}
          onSwiper={(swiper) => {
            movePagination(swiper);
          }}
          onSlideChange={(swiper) => {
            movePagination(swiper);
          }}
        >
          {sliderData.map((slide) => (
            <SwiperSlide key={slide.id}>
              <div className={`slide-wrapper ${slide.id === 7 ? "last" : ""}`}>
                <div className="content-inner">
                  <div className="image">
                    <div className="img-wrapper">
                      <img src={slide.image} alt={slide.title} />
                    </div>
                  </div>

                  <div className="footer-content">
                    <h4
                      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(slide.title)}}
                      className="title"
                    />
                    <p
                      className="desc"
                      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(slide.description)}}
                    />

                    <div className="stores">
                      {slide?.stores?.map((store) => (
                        <a
                          key={store.id}
                          href={store.link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img src={store.image} alt={store.name} />
                        </a>
                      ))}
                    </div>

                    <div className="cta-group">
                      <div className="swiper-button-prev hero">
                        <ArrowButton reverse />
                      </div>
                      <div className="swiper-button-next hero">
                        <ArrowButton />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}
